import React from "react";
import DepositTab from "./eachTab/DepositTab";
import WithdrawTab from "./eachTab/WithdrawTab";
import BorrowTab from "./eachTab/BorrowTab";
import RepayTab from "./eachTab/RepayTab";
import { Tab } from "@headlessui/react";

function classnames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const categories = ["Deposit", "Withdraw", "Borrow", "Repay"];

const Tabs = () => {
  return (
    <Tab.Group>
      <Tab.List className="flex space-x-1 rounded-xl px-11">
        {categories.map((category) => (
          <Tab
            key={category}
            className={({ selected }) =>
              classnames(
                "w-full pt-7 pb-5 font-Inter text-lg not-italic font-normal leading-normal",
                selected
                  ? "text-bodyColor border-b-2 border-b-bodyColor"
                  : "text-opaBodyColor border-none"
              )
            }
          >
            {category}
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className="mt-2">
        {categories.map((tab, idx) => (
          <Tab.Panel key={idx} className={classnames("px-7 py-5")}>
            {tab === "Deposit" ? (
              <DepositTab />
            ) : tab === "Withdraw" ? (
              <WithdrawTab />
            ) : tab === "Borrow" ? (
              <BorrowTab />
            ) : (
              <RepayTab />
            )}
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
};

export default Tabs;
